// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#Print div.print-body {
    padding: 0.25em;
}

#Print span.option-label {
    margin-right: 1em;
    width: 10em;
}

#Print .print-minimize-maximize {
    margin-left: 1em;
    padding: 0.25em;
}

#Print table.options-table {
    width: 100%;
}

#Print table.options-table td {
    padding: 0.125em 0;
}

#Print table.options-table td:first-child {
    max-width: 10em;
    overflow: hidden;
    text-overflow: ellipsis;
    padding-right: 0.25em;
    white-space: nowrap;
}

#Print table.options-table td:nth-child(2) {
    width: 99%;
}

#Print table.options-table td:nth-child(2) > * {
    width: 100%;
}

#Print table.options-table textarea {
    resize: vertical;
    min-height: 2em;
}

#Print div.button-bar {
    margin-top: 0.5em;
}

#Print div.button-bar > button {
    width: 100%;
}

div.print-output-window-body {
    width: 100%;
    height: 100%;
    position: relative;
}

div.print-output-window-body > iframe {
    border: 0;
    width: 100%;
    height: 100%;
}

span.print-output-window-wait {
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: rgba(200, 200, 200, 0.9);
}

span.print-output-window-wait div.spinner {
    width: 4em;
    height: 4em;
    margin-right: 1em;
}

#Print span.print-wait {
    display: flex;
    align-items: center;
}

#Print span.print-wait {
    display: flex;
    align-items: center;
}

#Print span.print-wait div.spinner {
    width: 1.25em;
    height: 1.25em;
    margin-right: 0.5em;
    flex: 0 0 auto;
}

#Print div.print-atlas-features {
    display: flex;
    flex-wrap: wrap;
    border: 1px solid var(--border-color);
    background-color: var(--input-bg-color);
}

#Print div.print-atlas-features > span {
    background-color: var(--border-color);
    color: var(--text-color);
    display: flex;
    align-items: center;
    padding: 0.25em;
    margin: 0.125em;
}

#Print div.print-atlas-features > span > span:first-child {
    margin-right: 0.5em;
}
`, "",{"version":3,"sources":["webpack://./plugins/style/Print.css"],"names":[],"mappings":"AAAA;IACI,eAAe;AACnB;;AAEA;IACI,iBAAiB;IACjB,WAAW;AACf;;AAEA;IACI,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,uBAAuB;IACvB,qBAAqB;IACrB,mBAAmB;AACvB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;AACtB;;AAEA;IACI,SAAS;IACT,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,SAAS;IACT,QAAQ;IACR,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,0CAA0C;AAC9C;;AAEA;IACI,UAAU;IACV,WAAW;IACX,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,cAAc;IACd,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,eAAe;IACf,qCAAqC;IACrC,uCAAuC;AAC3C;;AAEA;IACI,qCAAqC;IACrC,wBAAwB;IACxB,aAAa;IACb,mBAAmB;IACnB,eAAe;IACf,eAAe;AACnB;;AAEA;IACI,mBAAmB;AACvB","sourcesContent":["#Print div.print-body {\n    padding: 0.25em;\n}\n\n#Print span.option-label {\n    margin-right: 1em;\n    width: 10em;\n}\n\n#Print .print-minimize-maximize {\n    margin-left: 1em;\n    padding: 0.25em;\n}\n\n#Print table.options-table {\n    width: 100%;\n}\n\n#Print table.options-table td {\n    padding: 0.125em 0;\n}\n\n#Print table.options-table td:first-child {\n    max-width: 10em;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    padding-right: 0.25em;\n    white-space: nowrap;\n}\n\n#Print table.options-table td:nth-child(2) {\n    width: 99%;\n}\n\n#Print table.options-table td:nth-child(2) > * {\n    width: 100%;\n}\n\n#Print table.options-table textarea {\n    resize: vertical;\n    min-height: 2em;\n}\n\n#Print div.button-bar {\n    margin-top: 0.5em;\n}\n\n#Print div.button-bar > button {\n    width: 100%;\n}\n\ndiv.print-output-window-body {\n    width: 100%;\n    height: 100%;\n    position: relative;\n}\n\ndiv.print-output-window-body > iframe {\n    border: 0;\n    width: 100%;\n    height: 100%;\n}\n\nspan.print-output-window-wait {\n    position: absolute;\n    top: 0;\n    left: 0;\n    bottom: 0;\n    right: 0;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    background-color: rgba(200, 200, 200, 0.9);\n}\n\nspan.print-output-window-wait div.spinner {\n    width: 4em;\n    height: 4em;\n    margin-right: 1em;\n}\n\n#Print span.print-wait {\n    display: flex;\n    align-items: center;\n}\n\n#Print span.print-wait {\n    display: flex;\n    align-items: center;\n}\n\n#Print span.print-wait div.spinner {\n    width: 1.25em;\n    height: 1.25em;\n    margin-right: 0.5em;\n    flex: 0 0 auto;\n}\n\n#Print div.print-atlas-features {\n    display: flex;\n    flex-wrap: wrap;\n    border: 1px solid var(--border-color);\n    background-color: var(--input-bg-color);\n}\n\n#Print div.print-atlas-features > span {\n    background-color: var(--border-color);\n    color: var(--text-color);\n    display: flex;\n    align-items: center;\n    padding: 0.25em;\n    margin: 0.125em;\n}\n\n#Print div.print-atlas-features > span > span:first-child {\n    margin-right: 0.5em;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
